import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import withAuthorization from '../higherOrder/withAuthorization'

import { DASHBOARD, INTRO_QUESTIONS, MAIL_VERIFICATION, INTRO_PAGE } from '../../constants/routes'
import { getIntroQuestionsState } from '../../actions'
import { ThreeBounceSpinner } from '../Global/LoadingSpinner'
import { LoadingWrapper } from '../StyledComponents/Classifier/LoadingScreen'

class RedirectController extends Component {
    componentDidMount() {
        this.checkIntroQuestionStatus()
    }

    componentWillReceiveProps(newProps) {
        const { introQuestionsState, sessionState } = newProps
        const { history } = this.props

        if (!!sessionState.authUser && !sessionState.authUser.emailVerified) {
            history.push(MAIL_VERIFICATION)
        }

        if (introQuestionsState) {
            const questionsSet = ['done', 'skipped'].includes(introQuestionsState)

            if (questionsSet) {
                history.push(DASHBOARD)
            } else if (introQuestionsState === 'intro') {
                history.push(INTRO_QUESTIONS)
            } else if (introQuestionsState === 'none') {
                history.push(INTRO_PAGE)
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.sessionState.idToken && !!this.props.sessionState.idToken) {
            this.checkIntroQuestionStatus()
        }
    }

    checkIntroQuestionStatus() {
        if (!!this.props.sessionState
            && !!this.props.sessionState.idToken
            && !!this.props.sessionState.authUser) {
            const { token } = this.props.sessionState.idToken
            this.props.getIntroQuestionsState(this.props.sessionState.authUser.uid, token)
        }
    }

    render() {
        return (
            <LoadingWrapper>
                <ThreeBounceSpinner />
            </LoadingWrapper>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    sessionState: state.sessionState,
    introQuestionsState: state.introQuestions.status,
})

export default compose(
    withAuthorization(authCondition),
    withRouter,
    connect(mapStateToProps, {
        getIntroQuestionsState,
    })
)(RedirectController)



// WEBPACK FOOTER //
// ./src/components/pages/RedirectController.js